enum SITE_TYPE {
  SAAS = 'saas',
  WEB3 = 'web3',
  CMS = 'cms',
  PORTFOLIO = 'portfolio',
  SHOP = 'shop',
  OTHER = 'other',
}
export const SITE_TYPE_NAME = {
  [SITE_TYPE.SAAS]: 'SaaS',
  [SITE_TYPE.WEB3]: 'Web3',
  [SITE_TYPE.CMS]: 'CMS',
  [SITE_TYPE.PORTFOLIO]: 'Portfolio',
  [SITE_TYPE.SHOP]: 'Shop',
  [SITE_TYPE.OTHER]: 'Other',
};

export enum TEMPLATE_SITE_TYPE {
  SAAS = 'saas',
  AGENCY = 'agency',
  AI = 'ai',
  BUSINESS = 'business',
  EBOOK = 'ebook',
  CREATOR_PROFILE = 'creator-profile',
  DESIGN_KIT = 'design-kit',
  DIGITAL_PRODUCT = 'digital-product',
  EVENT = 'event',
  DOCUMENTATION = 'documentation',
  FORM = 'form',
  TEAM = 'team',
  TERMS_POLICY = 'terms-policy',
}
export const TEMPLATE_SITE_TYPE_NAME = {
  [TEMPLATE_SITE_TYPE.SAAS]: 'SaaS / Software',
  [TEMPLATE_SITE_TYPE.AGENCY]: 'Agency',
  [TEMPLATE_SITE_TYPE.AI]: 'Artificial Intelligence (AI)',
  [TEMPLATE_SITE_TYPE.BUSINESS]: 'Business',
  [TEMPLATE_SITE_TYPE.EBOOK]: 'Book / E-Book',
  [TEMPLATE_SITE_TYPE.CREATOR_PROFILE]: 'Creator Profile',
  [TEMPLATE_SITE_TYPE.DESIGN_KIT]: 'Design Kit',
  [TEMPLATE_SITE_TYPE.DIGITAL_PRODUCT]: 'Digital Product',
  [TEMPLATE_SITE_TYPE.EVENT]: 'Event',
  [TEMPLATE_SITE_TYPE.DOCUMENTATION]: 'Documentation',
  [TEMPLATE_SITE_TYPE.FORM]: 'Form',
  [TEMPLATE_SITE_TYPE.TEAM]: 'Team',
  [TEMPLATE_SITE_TYPE.TERMS_POLICY]: 'Terms & Policy',
};

export default SITE_TYPE;
